import { render, staticRenderFns } from "./GenericTable.vue?vue&type=template&id=5e0505be&scoped=true"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"
import style0 from "./GenericTable.vue?vue&type=style&index=0&id=5e0505be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0505be",
  null
  
)

export default component.exports